module.exports = global["Masonry"] = require("-!/home/jenkins/agent/workspace/p_otpagrar-frontend-build_master/application/static/node_modules/masonry-layout/masonry.js");


//////////////////
// WEBPACK FOOTER
// ./~/masonry-layout/masonry.js
// module id = 354
// module chunks = 2